export let EModalPerpRoutes=function(EModalPerpRoutes){EModalPerpRoutes["PerpTradersHistoryList"]="PerpTradersHistoryList";return EModalPerpRoutes;}({});